import FiltersType from './listingFiltersTypesConstants';

export const VAT_FILTERS = [
  {
    key: 'fulltext',
    placeholder: 'Wpisz frazę do znalezienia',
    shortPlaceholder: 'Szukaj',
    badge: 'Szukana fraza:',
    testName: 'hub_filter_search',
    inputType: FiltersType.TEXT_SEARCH_TYPE,
    reset: async () => ({ value: '' }),
  },
  {
    key: 'needs_verification',
    getItems: async () => [
      { value: 0, label: 'Nie' },
      { value: 1, label: 'Tak' },
    ],
    reset: async () => null,
    placeholder: 'Czy wymaga weryfikacji?',
    badge: 'Wymaga weryfikacji:',
    testName: 'test_filter_evidence_needs_verifiacation',
    inputType: FiltersType.SELECT_TYPE,
  },
  {
    key: '_has_file',
    getItems: async () => [
      { value: 0, label: 'Nie' },
      { value: 1, label: 'Tak' },
    ],
    reset: async () => null,
    placeholder: 'Czy posiada plik?',
    badge: 'Plik:',
    testName: 'test_filter_evidence_file',
    inputType: FiltersType.SELECT_TYPE,
  },
  {
    key: '_net_value',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Kwota netto:',
    testName: 'test_filter_evidence_net_value',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_gross_value',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Kwota brutto:',
    testName: 'test_filter_evidence_gross_value',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_deduction_date',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Data odliczenia:',
    testName: 'test_filter_evidence_deduction_date',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'date',
  },
  {
    key: 'sale_date',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Data sprzedaży:',
    testName: 'test_filter_evidence_conclusion_date',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'date',
  },
  {
    key: 'issue_date',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Data wystawienia:',
    testName: 'test_filter_evidence_issue_date',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'date',
  },
];
